import { HTMLAttributes, useState } from 'react';
import Components from '@/website/components/NewLandingPages';
import WidgetEmbed from '@/website/components/WidgetEmbed';
import { ContentfulPageProps } from '@/website/lib/getContentfulData';
import { Box } from '@mui/material';

type GoodsInTransitUSLandingPageViewProps = HTMLAttributes<HTMLDivElement> & ContentfulPageProps;
const GoodsInTransitUSLandingPageView = (props: GoodsInTransitUSLandingPageViewProps) => {
  const { post, promotion } = props;
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);

  /** Promotion logic */
  const hasActivePromotion = promotion?.status === 'active';
  const insuranceType = new Map([
    ['goods-in-transit-insurance', 'goods-in-transit'],
    ['business-insurance', 'business-insurance'],
    ['construction-insurance', 'hired-in-plant'],
  ]);
  const queryParams = new URLSearchParams();
  if (hasActivePromotion) {
    queryParams.set('utm_source', 'jove-website');
    queryParams.set('utm_medium', 'promotion');
    queryParams.set('utm_campaign', promotion.slug);
    queryParams.set('promotion_id', promotion.id);
    queryParams.set('display_insurance', insuranceType.get(promotion.insurance_type));
    queryParams.set('providerCode', promotion.insurance_providers[0].code);
  }

  const quoteSrc = hasActivePromotion ? `${process.env.NX_QUOTE_ENDPOINT}/?${queryParams.toString()}` : `${process.env.NX_QUOTE_ENDPOINT}`;
  /** End of promotion logic */

  const baseImgUrl = 'https://storage.googleapis.com/jove-public-images/website/landing-pages/motor-truck-cargo';
  return (
    <Box>
      {hasActivePromotion ? (
        <Components.PromotionHero promotion={promotion} imgFallback={`${baseImgUrl}/hero-bg.png`} onClick={() => setIsWidgetOpen(true)} post={post} />
      ) : (
        <Components.Hero post={post} setIsWidgetOpen={setIsWidgetOpen} bgImage={`${baseImgUrl}/hero-bg.png`} />
      )}
      <Components.ProblemSolution problemImg={`${baseImgUrl}/problem-image.png`} solutionImg={`${baseImgUrl}/solution-image.png`} post={post} />
      <Components.SeeInAction post={post} setIsWidgetOpen={setIsWidgetOpen} />
      <Components.Features post={post} featureImg={`${baseImgUrl}/features.png`} />
      <Components.TypesOfDrivers post={post} typeOneImg={`${baseImgUrl}/courier.png`} typeTwoImg={`${baseImgUrl}/driver.png`} />
      <Components.OurProducts post={post} />
      <Components.WhyJove post={post} />
      <Components.SwitchToJove post={post} />
      <Components.Testimonial imgSrc={`${baseImgUrl}/business-owner-image.png`} post={post} />
      <Components.Referral post={post} />
      <Components.Explore post={post} />
      <Components.FAQ post={post} />
      <WidgetEmbed isOpen={isWidgetOpen} quoteSrc={quoteSrc} />
    </Box>
  );
};

export default GoodsInTransitUSLandingPageView;
